import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

import { AuthenticationService } from '../../authentication/authentication.service';
import { CompanyMember } from '../../models/CompanyMember';

@Injectable({
    providedIn: 'root',
})
export class IntegrationDetailsService {
    httpOptions = {};
    subscriptions: Subscription[] = [];

    constructor(private httpClient: HttpClient, private authenticationService: AuthenticationService) {
        this.httpOptions = authenticationService.getHeaders();
    }

    getLogedInMembers() {
        return this.httpClient.get<CompanyMember[]>(environment.baseUrl + '/google/getLoggedInMembers', this.httpOptions);
    }

    getIsLogedIn() {
        return this.httpClient.get<boolean>(environment.baseUrl + '/google/isLoggedIn', this.httpOptions);
    }

    loginWithGoogle() {
        return this.httpClient.get<boolean>(environment.baseUrl + '/google/login', this.httpOptions);
    }

    logoutWithGoogle() {
        return this.httpClient.get<boolean>(environment.baseUrl + '/google/logout', this.httpOptions);
    }
}
